import { z } from "zod";

const symbolRefSchema = z.object({
  x: z.number(),
  y: z.number(),
});

export const hmiSymbolLayerSchema = z.object({
  id: z.string().trim().min(1).max(128),
  type: z.enum(["path", "rect", "circle", "line", "text"]),
  style: z.record(z.string(), z.unknown()).default({}),
  bindings: z.array(z.string().trim().min(1).max(128)).default([]),
  ref: symbolRefSchema.nullable().optional(),
});

export const hmiSymbolDefinitionSchema = z.object({
  id: z.string().trim().min(1).max(128),
  version: z.number().int().min(1),
  title: z.string().trim().min(1).max(255),
  category: z.enum(["hvac", "process", "utility", "generic"]),
  builtIn: z.boolean().default(false),
  viewport: z.object({
    width: z.number().positive(),
    height: z.number().positive(),
  }),
  layers: z.array(hmiSymbolLayerSchema).min(1).max(128),
  metadata: z
    .object({
      tenantId: z.string().uuid().nullable().optional(),
      description: z.string().max(1000).nullable().optional(),
    })
    .nullable()
    .optional(),
});

export const hmiSymbolInstanceSchema = z.object({
  definitionId: z.string().trim().min(1).max(128),
  definitionVersion: z.number().int().min(1),
  overrides: z.record(z.string(), z.unknown()).default({}),
});

export type HmiSymbolDefinition = z.infer<typeof hmiSymbolDefinitionSchema>;
export type HmiSymbolInstance = z.infer<typeof hmiSymbolInstanceSchema>;
export type HmiSymbolLayer = z.infer<typeof hmiSymbolLayerSchema>;
